import * as React from 'react';

import ColorLegendModal from 'af-root/scenes/Company/ScheduleBoard/Shared/ColorLegendModal';

import { SCREEN_BREAKPOINT_L } from 'af-constants/values';

import { Button } from '@acceligentllc/storybook';

interface State {
	isHelpModalOpen: boolean;
	isButtonSmall: boolean;
}

type Props = Record<string, never>;

class ColorLegend extends React.PureComponent<Props, State> {

	state: State = {
		isHelpModalOpen: false,
		isButtonSmall: window.innerWidth < SCREEN_BREAKPOINT_L,
	};

	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}

	updateWindowDimensions = () => {
		this.setState(() => ({ isButtonSmall: window.innerWidth < SCREEN_BREAKPOINT_L }));
	};

	openHelpModal = () => this.setState(() => ({ isHelpModalOpen: true }));

	closeHelpModal = () => this.setState(() => ({ isHelpModalOpen: false }));

	render() {
		const { isHelpModalOpen, isButtonSmall } = this.state;
		return (
			<>
				<Button
					icon="MarkQuestionOutline"
					label={isButtonSmall ? undefined : 'Legend'}
					onClick={this.openHelpModal}
					style="secondary"
					tooltip={isButtonSmall ? 'Legend' : undefined}
					tooltipPosition={isButtonSmall ? 'bottom' : undefined}
				/>
				<ColorLegendModal
					closeModal={this.closeHelpModal}
					modalVisible={isHelpModalOpen}
				/>
			</>
		);
	}
}

export default ColorLegend;
